<div class="form-field">
  <fieldset [class.disabled]="disabled">
    <div class="rms-toggle-wrapper" [class.disabled]="disabled" (click)="toggle()">
      <div [ngClass]="largeToggle ? 'toggle-switch-large' : 'toggle-switch'" [class.checked]="isChecked()">
        <div class="toggle-handle"></div>
      </div>
    </div>
    <legend>{{label}}</legend>
  </fieldset>
</div>
